// extracted by mini-css-extract-plugin
export default {"backgroundImg":"mfr-BwHyx_7k"};